import * as core from '../../../../../../../core'

import { query } from './salary-to-bill-rate.query'

export const RESOURCE = {
  payload: {
    alias: 'billability-calculator.salary-to-bill-rate',
    description:
      'Converts a salary to a bill rate based on the Gross Margin and Fringe',
    name: 'Billability Calculator: Salary to Bill Rate',
    query,
    variables: [
      {
        defaultValue: 0,
        id: 'BaseSalary',
        name: 'Base Salary',
        type: core.common.value.types.Intrinsic.Integer,
      },
      {
        defaultValue: 33.5,
        id: 'Fringe',
        name: 'Fringe',
        type: core.common.value.types.Intrinsic.Percent,
      },
      {
        defaultValue: 2080,
        id: 'TotalHours',
        name: 'Total Hours',
        type: core.common.value.types.Intrinsic.Integer,
      },
      {
        defaultValue: 45,
        id: 'GrossMargin',
        name: 'Gross Margin',
        type: core.common.value.types.Intrinsic.Percent,
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
